import account from './account'

export default account
